import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsermag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 11,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#FFF",
		fillRule: "nonzero",
		children: /* @__PURE__ */ _jsx("path", { d: "M8 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm0-3a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2zM13 5c-.898 0-1.724.368-2.287.984A4.157 4.157 0 0 0 8 5a4.136 4.136 0 0 0-2.713.986C4.684 5.324 3.856 5 3 5 1.345 5 0 6.242 0 7.77v1.845c0 .256.224.462.5.462H4v.461c0 .256.224.462.5.462h7c.276 0 .5-.206.5-.462v-.461h3.5c.276 0 .5-.206.5-.462V7.77C16 6.24 14.662 5 13 5zM1 9.154V7.769c0-1.018.897-1.846 2-1.846.636 0 1.255.276 1.64.791A3.479 3.479 0 0 0 4 8.692v.462H1zm10 .923H5V8.692C5 7.21 6.294 5.923 8 5.923c1.695 0 3 1.277 3 2.77v1.384zm4-.923h-3v-.462c0-.71-.236-1.401-.641-1.98A2.049 2.049 0 0 1 13 5.923c1.112 0 2 .827 2 1.846v1.385zM13 4c1.103 0 2-.897 2-2s-.897-2-2-2c-1.102 0-2 .897-2 2s.898 2 2 2zm0-3a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2zM3 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm0-3a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2z" })
	})
});
export default SvgUsermag;
